/**
 * 날짜/시각 포맷 유틸
 *
 * 백엔드는 ISO 8601 UTC 문자열(예: "2026-08-18T05:32:07Z")을 내려준다.
 * 화면에는 한국 표준시(KST, UTC+9)로 변환해 표기한다.
 * 브라우저 로컬 타임존과 무관하게 항상 Asia/Seoul로 고정한다.
 */

/** KST 날짜(YYYY-MM-DD) 포맷터. */
const kstDateFmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** KST 시각(HH:mm:ss, 24시간) 포맷터. */
const kstTimeFmt = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Seoul',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

/** 날짜·시각 두 파트로 분리된 KST 표기. */
export interface KstParts {
  /** YYYY-MM-DD */
  date: string;
  /** HH:mm:ss */
  time: string;
}

/**
 * ISO 문자열을 KST 날짜/시각 파트로 변환한다.
 * 값이 없거나 파싱 불가하면 null.
 */
export function toKstParts(iso: string | null | undefined): KstParts | null {
  if (!iso) {
    return null;
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return null;
  }
  return { date: kstDateFmt.format(d), time: kstTimeFmt.format(d) };
}

/**
 * ISO 문자열을 "YYYY-MM-DD HH:mm:ss" (KST) 한 줄로 포맷한다.
 * 값이 없으면 대시(—).
 */
export function formatKst(iso: string | null | undefined): string {
  const parts = toKstParts(iso);
  return parts ? `${parts.date} ${parts.time}` : '—';
}
